import Block from '../block'
import { lockScroll, unlockScroll } from 'scripts/scroll-lock'

export default class BlockForm extends Block {
	static title = 'block-form'

	constructor($el) {
		super($el)

		this.form = this.$el.find('form')
		this.formMessage = this.$el.findElement('message')
		this.formMessageButton = this.$el.findElement('message-close')
		this.loader = this.$el.findElement('loader')

		if (this.$el.hasModifier('lightbox')) {
			// for lightbox open
			this.toggleButton = this.$el.findElement('toggle')
			// for lightbox close
			this.closeButton = this.$el.findElement('close')
			this.cancelButton = this.$el.findElement('cancel')
			this.lightboxOverlay = this.$el.findElement('fields-overlay')

			this.toggleButton.on('click', () => this.toggleLightbox(true))

			this.closeButton
				.add(this.cancelButton)
				.add(this.lightboxOverlay)
				.on('click', () => this.toggleLightbox(false))
		}

		this.formMessageButton.on('click', () => {
			this.formMessage.addClass('hidden')
		})

		this.form.on('submit', (e) => {
			e.preventDefault()

			const checkboxes = this.form.find('.block-form__checkbox-group--required')

			if (checkboxes.length) {
				checkboxes.each((index, el) => {
					if ($(el).find('input[type="checkbox"]:checked').length) {
						$(el).find('sl-alert').removeAttr('open')
						this.submitForm()
					} else {
						$(el).find('sl-alert').prop('open', 'true')
					}
				})
			} else {
				this.submitForm()
			}
		})
	}

	submitForm() {
		this.setLoading(true)
		const data = new FormData(this.form.get(0))
		data.append('ajax', true)

		$.ajax({
			method: 'POST',
			processData: false,
			contentType: false,
			cache: false,
			url: window.location.href,
			data: data,
		})
			.done((json) => {
				if (!json.error && json.success) {
					// hide lightbox after send
					if (this.$el.hasModifier('lightbox')) {
						this.toggleLightbox(false)
					}

					this.form.trigger('reset')
					if (this.formMessage) {
						this.formMessage.removeClass('hidden')
					}

					$(document).trigger('message:success', { message: json.message })
				} else {
					$(document).trigger('message:error', { message: json.message })
				}
			})
			.fail((json) => {
				$(document).trigger('message:error', { message: json.message })
			})
			.always(() => {
				this.setLoading(false)
				this.resetCaptcha()
			})
	}

	/**
	 * Clears the reCAPTCHA tick: the server spends the token on every submit, so a resubmit needs a new one.
	 * The widget id comes from the loader in utils/recaptcha.js; before it renders there is nothing to reset.
	 *
	 * @returns {void}
	 */
	resetCaptcha() {
		const widget = this.form.find('.g-recaptcha').get(0)

		if (widget && widget.dataset.widgetId !== undefined && window.grecaptcha) {
			window.grecaptcha.reset(widget.dataset.widgetId)
		}
	}

	/**
	 * Opens or closes the lightbox, locking the page scroll while it is open
	 *
	 * @param {boolean} bool
	 * @returns {void}
	 */
	toggleLightbox(bool) {
		// the scroll lock counts its locks, so only act on a state change
		if (bool === this.$el.hasModifier('lightbox-active')) {
			return
		}

		if (bool) {
			// use modifier because of precedence
			this.$el.addModifier('lightbox-active')
			lockScroll()
		} else {
			this.$el.removeModifier('lightbox-active')
			unlockScroll()
		}
	}

	setLoading(bool) {
		if (bool) {
			this.form.find('button[type="submit"]').prop('disabled', true)
			this.loader.removeClass('hidden')
		} else {
			this.form.find('button[type="submit"]').prop('disabled', false)
			this.loader.addClass('hidden')
		}
	}
}
